"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.b2main = void 0;
exports.b2main = {
    "addresses": {
        "ProxyAdmin": "0xd6062F989BCf5DD6871A83671C4aABD05e25BA1b",
        "Multicall2": "0xBB134359b3E6794127c7232680F959CE6BF60814",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0x607728B392D4d18e7fe072f0F8D4EFd5c8D0F5A4",
        "FeedPriceOracle": "0xd96fff1B1eA8eFfb70035e2FD583Da29dC7193f9",
        "CompLogic": "0x1fbDb3b715c82DCD52BCF06fcc18819951aa9264",
        "RedemptionManager": "0x98Ec4C9605D69083089eCAf353037b40017b758e",
        "Timelock": "0x313Ba7E5508e3deb17CD5abA9D7A1b15BdE77879",
        "Comptroller": "0xdD9C863197df28f47721107f94eb031b548B5e48",
        "sdrBTC": "0xAbcdc5827f92525F56004540459045Ec3e432ebF",
        "BTC": "0x0000000000000000000000000000000000000000",
        "CErc20": "0x8c1ad24cA39FE45E97CD9862364128406E3B03F3",
        "suErc20": "0x9aa55bCf3E41D0d98FCe816C4eC6E791B0f6d154",
        "JumpRate#StableBC": "0x0f0af0e3dEb8A884fCB54907BA571c84C2EB3042",
        "JumpRate#Others": "0x621492F55F6b7A29FDaC0844B1A6C849985A4b82",
        "JumpRate#BTCBC_AltStables": "0x2d9b96648C784906253c7FA94817437EF59Cf226",
        "ZeroRate": "0x7032b30FEF73af49e314e5A09B449046ef046309",
        "sdrUSDC": "0x163cEbBD83A4e2821fF06C9b0707A8A64FEc0AbC",
        "USDC": "0xE544e8a38aDD9B1ABF21922090445Ba93f74B9E5",
        "sdrUSDT": "0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488",
        "USDT": "0x681202351a488040Fa4FdCc24188AfB582c9DD62",
        "sdruBTC": "0x7465fedB29023d11effe8C74E82A7ecEBf15E947",
        "uBTC": "0x796e4D53067FF374B89b2Ac101ce0c1f72ccaAc2",
        "sdrsuUSD": "0x8C38b023Afe895296e2598AE111752223185b35c",
        "suUSD": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
        "sdrsuBTC": "0xb1FdC3f660b0953253141B2509c43014d5d3d733",
        "suBTC": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0x163cEbBD83A4e2821fF06C9b0707A8A64FEc0AbC",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xE544e8a38aDD9B1ABF21922090445Ba93f74B9E5",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488",
            "underlySym": "USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x681202351a488040Fa4FdCc24188AfB582c9DD62",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdruBTC",
            "ctokenAddr": "0x7465fedB29023d11effe8C74E82A7ecEBf15E947",
            "underlySym": "uBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x796e4D53067FF374B89b2Ac101ce0c1f72ccaAc2",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0x8C38b023Afe895296e2598AE111752223185b35c",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0xb1FdC3f660b0953253141B2509c43014d5d3d733",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrBTC",
            "ctokenAddr": "0xAbcdc5827f92525F56004540459045Ec3e432ebF",
            "underlySym": "BTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#BTCBC_AltStables",
            "contract": "JumpRateModelV2",
            "address": "0x2d9b96648C784906253c7FA94817437EF59Cf226",
            "tokens": [
                "BTC",
                "BTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.0889",
            "jumpMultiplierPerYear": "5.52727",
            "kink": "0.45"
        },
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0x0f0af0e3dEb8A884fCB54907BA571c84C2EB3042",
            "tokens": [
                "USDC",
                "USDT"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.09333",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0x621492F55F6b7A29FDaC0844B1A6C849985A4b82",
            "tokens": [
                "uBTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.15555",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0x7032b30FEF73af49e314e5A09B449046ef046309",
            "tokens": [
                "suUSD",
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=b2main.js.map